module.exports = __webpack_public_path__ + "img/topo_map.7b2a66ac.jpg";